import React from "react"
import useDictionary from "../../../hooks/useDictionary"

interface Props {
  formFunctions: any
  name?: string
  label: string
  rows?: number
  placeholder?: string
  required?: boolean
  hideLabel?: boolean
  instructions?: string
  maxLength?: number
  pageContext: any
}

const defaultProps = {
  rows: 2,
  placeholder: "",
}

const TextareaField: React.FC<Props> = props => {
  // react-hook-form
  const register = props.formFunctions.register
  const errors = props.formFunctions.errors

  // field props
  const input_name = props.name || props.label
  const input_id = input_name.split(" ").join("_")

  return (
    <div className="form__field">
      <label htmlFor={input_id}>
        {props.hideLabel ? (
          <span className="show-for-sr">{props.label}</span>
        ) : (
          <>
            {props.label}
            {props.required ? " *" : ""}
          </>
        )}
      </label>

      <div className="field__input" style={{ verticalAlign: "top" }}>
        <textarea
          id={input_id}
          rows={props.rows}
          placeholder={props.placeholder}
          maxLength={props.maxLength ? props.maxLength : undefined}
          className={errors && errors[input_name] && "error"}
          {...register(input_name, {
            required: props.required
              ? `${props.label} ${useDictionary(
                  "is required",
                  props.pageContext.locale
                )}`
              : false,
            maxLength: props.maxLength ? props.maxLength : undefined,
          })}
        />
      </div>

      {props.instructions && (
        <div className="field__help">{props.instructions}</div>
      )}

      {errors.hasOwnProperty(input_name) && (
        <div className="field__error">{errors[input_name].message}</div>
      )}
    </div>
  )
}

TextareaField.defaultProps = defaultProps

export default TextareaField
